export const ApiUrl = `https://backend.koncurent.com`;
// export const ApiUrl = `https://backend.staging.koncurent.com`;
